import { ua } from '../../../util/user-agent';

export class Controller {

    /** @ngInject */
    constructor($sce) {
        this.$sce = $sce;
    }

    $onInit() {
        // this.isMacOS = ua.isMacOS();
        // Proximity removed by Faking the user agent check
        this.isMacOS = false;
        // this.setBluetoothUrl();
    }

    $onChanges() {
        // this.setBluetoothUrl();
    }

    setBluetoothUrl() {
        if (this.bluetoothCode && this.isMacOS) {
            const bluetoothUrl = `saaspass://bluepass?${this.bluetoothCode}`;
            this.bluetoothUrl = this.$sce.trustAsResourceUrl(bluetoothUrl);
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/sp-proximity/sp-proximity.controller.js